import BarChartIcon from '@mui/icons-material/BarChart';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import PieChartIcon from '@mui/icons-material/PieChart';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { Paper, Stack, Typography } from '@mui/material';

interface ChartSelectorProps {
    availableCharts: string[];
    onSelectChart: (chart: string) => void;
    selectedChart: string;
}

function ChartSelector({ availableCharts, onSelectChart, selectedChart }: Readonly<ChartSelectorProps>) {
    return (
        <Stack
            direction="row"
            sx={{
                flexWrap: 'wrap',
                gap: 1.5,
                mb: 2,
            }}
        >
            {availableCharts.map((chart) => (
                <Paper
                    elevation={2}
                    key={chart}
                    onClick={() => onSelectChart(chart)}
                    sx={{
                        '&:hover': {
                            backgroundColor: selectedChart === chart ? 'primary.dark' : 'action.hover',
                        },
                        alignItems: 'center',
                        backgroundColor: selectedChart === chart ? 'primary.main' : 'background.paper',
                        borderRadius: 1,
                        color: selectedChart === chart ? 'primary.contrastText' : 'text.primary',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        height: 60,
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        width: 60,
                    }}
                >
                    {chart === 'Bar' && <BarChartIcon />}
                    {chart === 'Line' && <ShowChartIcon />}
                    {chart === 'Pie' && <PieChartIcon />}
                    {chart === 'Scatter' && <ScatterPlotIcon />}
                    {chart === 'Gauge' && <DataUsageIcon />}
                    <Typography
                        sx={{
                            fontSize: '0.7rem',
                            mt: 0.5,
                            textAlign: 'center',
                        }}
                        variant="caption"
                    >
                        {chart}
                    </Typography>
                </Paper>
            ))}
        </Stack>
    );
}

export default ChartSelector;
